import React, { FC, useState, InputHTMLAttributes, ChangeEvent, ChangeEventHandler, KeyboardEvent, ClipboardEvent, useEffect } from 'react'
import RangeSlider from 'react-bootstrap-range-slider';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';
import { Col } from 'reactstrap';

interface IRangeInput extends InputHTMLAttributes<HTMLInputElement> {
  maxValue?: number,
  minValue?: number,
  step?: number,
  defaultValue?: any,
  onChange?: any,
  disabled?: boolean
}

const RangeInput: FC<IRangeInput> = (props: IRangeInput) => {
  const { onChange, maxValue = 5, minValue = 0, step = 1, defaultValue = 0, disabled = false } = props

  const [value, setValue] = React.useState(defaultValue);

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setValue(defaultValue)
    }
    return () => {
      isMounted = false
    }
  }, [defaultValue])

  return (
    <Form>
      <Form.Group as={Row}>
        <Col xs="9">
          <RangeSlider
            value={value}
            onChange={e => {
              setValue(e.target.value);
              onChange(e);
            }}
            min={minValue}
            max={maxValue}
            step={step}
            disabled={disabled}
            className="w-100"
          />
        </Col>
        <Col xs="3">
          <Form.Control type="number" value={value}
            disabled={disabled}
            onChange={e => {
              const val = parseInt(e.target.value) > maxValue ? maxValue : parseInt(e.target.value) < minValue ? minValue : parseInt(e.target.value);
              setValue(val);
              onChange(e);
            }} />
        </Col>
      </Form.Group>
    </Form>
  );
}

export default RangeInput
